import { StoreConfig, Store } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { UserModel } from '@app/shared/models/api/user.model';

export interface AkitaFirebaseState {
  firebaseUser: any | null;
  user: UserModel | null;

  token: string | null;
  error: Record<string, any> | null;
  firebaseError: any | null;
  sessionId: string;
  lastUpdated: Date | null;
}

export function createInitialState(): AkitaFirebaseState {
  return {
    firebaseUser: null,
    user: null,
    token: null,
    error: null,
    firebaseError: null,
    lastUpdated: new Date(),
    sessionId: '',
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'firebase-auth', resettable: true })
export class AkitaFirebaseStore extends Store<AkitaFirebaseState> {
  constructor() {
    super(createInitialState());
  }

  public setError(error: unknown): void {
    this.update({
      error: error as any,
      lastUpdated: new Date(),
    });
  }

  public setFirebaseUser(user: any | null): void {
    this.update({
      firebaseUser: user,
      error: null,
      lastUpdated: new Date(),
    });
  }

  public setApiUser(user: UserModel | null): void {
    this.update({
      user,
      error: null,
      lastUpdated: new Date(),
    });
  }

  public setToken(token: string | null): void {
    this.update({
      token,
      error: null,
      lastUpdated: new Date(),
    });
  }

  public updateToken(token?: string | null): void {
    this.update({
      token: token || null,
      lastUpdated: new Date(),
    });
  }

  public setSessionId(sessionId: string): void {
    this.update({
      sessionId,
      lastUpdated: new Date(),
    });
  }
}
